import type { Translations } from './de'

const ro: Translations = {
  'language.flag': '🇷🇴',
  'language.name': 'Română',
  'navigation.home': 'Acasă',
  'navigation.language': 'Limbă',
  'navigation.openMenu': 'Deschide meniul',
  'navigation.closeMenu': 'Închide meniul',
  'navigation.skipToContent': 'Salt la conținut',
  'categories.sightseeing.name': 'Obiective turistice',
  'categories.sightseeing.heading': 'Cele mai populare obiective turistice din Augsburg',
  'categories.sightseeing.lead': 'De la patrimoniul mondial UNESCO la Fuggerei, Augsburg are mai multe de oferit decât crezi.',
  'categories.events.name': 'Evenimente',
  'categories.events.heading': 'Toate evenimentele dintr-o privire',
  'categories.events.lead': 'Concerte, piețe, tururi ghidate: află ce se întâmplă săptămâna aceasta în Augsburg.',
  'categories.blog.name': 'Noutăți',
  'categories.blog.heading': 'Noutăți din Augsburg',
  'categories.blog.lead': 'Informații de fond, istoria orașului și subiecte actuale de citit și de povestit mai departe.',
  'categories.emptyTitle': 'Încă nimic aici',
  'categories.emptyDescription': 'Încă nu există pagini în această secțiune. Revino în curând.',
  'home.title': 'Bun venit în Augsburg',
  'home.intro': 'Fie că este o excursie în oraș, o călătorie de afaceri sau o vizită în familie, aici găsești toate informațiile importante pentru timpul petrecut în Augsburg.',
  'home.sightseeing.eyebrow': 'Oraș din patrimoniul mondial UNESCO',
  'home.sightseeing.title': 'Descoperă obiectivele turistice',
  'home.sightseeing.lead': 'De la patrimoniul mondial UNESCO la Fuggerei, Augsburg are mai multe de oferit decât crezi.',
  'home.sightseeing.action': 'Descoperă acum',
  'home.events.eyebrow': 'Ce se întâmplă în Augsburg?',
  'home.events.title': 'Găsește evenimente',
  'home.events.lead': 'Nu mai rata niciun concert, târg de vechituri sau festival. Pe pagina noastră de evenimente ești mereu la curent.',
  'home.events.action': 'Toate evenimentele',
  'home.blog.eyebrow': 'Povești din oraș',
  'home.blog.title': 'Noutăți și curiozități',
  'home.blog.lead': 'Aici găsești tot ce este important despre Augsburg, ca să știi totul în timpul vizitei tale.',
  'home.blog.action': 'Spre blog',
  'home.language.eyebrow': 'Augsburg este internațional',
  'home.language.title': 'Treci la limba ta',
  'home.language.lead': 'Acest site este disponibil în mai multe limbi. Vrei să schimbi limba?',
  'home.highlights.eyebrow': 'Selectate pentru tine',
  'home.highlights.title': 'Recomandările noastre',
  'home.highlights.lead': 'Pentru un început bun am adunat pentru tine câteva repere din Augsburg. Lectură plăcută!',
  'search.placeholder': 'Caută...',
  'search.clear': 'Șterge căutarea',
  'search.label': 'Caută pagini',
  'search.results': '{{count}} rezultate pentru „{{query}}”',
  'search.emptyTitle': 'Niciun rezultat',
  'search.emptyDescription': 'Nu am găsit nimic pentru această căutare. Încearcă un alt termen.',
  'pagination.label': 'Pagini',
  'pagination.previous': 'Pagina anterioară',
  'pagination.next': 'Pagina următoare',
  'pagination.page': 'Pagina {{page}}',
  'pagination.summary': '{{start}}–{{end}} din {{total}}',
  'page.back': 'Înapoi',
  'page.readMore': 'Află mai multe',
  'page.tableOfContents': 'Pe această pagină',
  'page.openInGoogleMaps': 'Deschide în Google Maps',
  'map.copyAddress': 'Copiază adresa',
  'map.copied': 'Copiat',
  'map.copyFailed': 'Copierea nu este posibilă',
  'map.routeInGoogleMaps': 'Traseu în Google Maps',
  'map.zoomIn': 'Mărește',
  'map.zoomOut': 'Micșorează',
  'map.showAll': 'Arată tot',
  'attribution.toggle': 'Afișează sau ascunde sursele',
  'map.gestures.windows': 'Folosește Ctrl + derulare pentru a mări harta',
  'map.gestures.mac': 'Folosește ⌘ + derulare pentru a mări harta',
  'map.gestures.mobile': 'Folosește două degete pentru a muta harta',
  'map.loading': 'Se încarcă harta …',
  'map.failed': 'Harta nu a putut fi încărcată.',
  'map.showPlace': 'Arată {{name}} pe hartă',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'aprox. {{duration}} pe jos',
  'map.route.stops': '{{count}} opriri',
  'map.route.leg': '{{distance}} · aprox. {{duration}}',
  'mapIcons.landmark': 'Obiectiv turistic',
  'mapIcons.church': 'Biserică',
  'mapIcons.museum': 'Muzeu',
  'mapIcons.park': 'Parc și natură',
  'mapIcons.viewpoint': 'Punct de belvedere',
  'mapIcons.cafe': 'Cafenea',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurant',
  'mapIcons.shop': 'Cumpărături',
  'mapIcons.event': 'Loc de evenimente',
  'mapIcons.transport': 'Transport',
  'mapIcons.place': 'Loc',
  'footer.imprint': 'Informații legale',
  'footer.privacy': 'Politica de confidențialitate',
  'footer.mediaLicense': 'Drepturi asupra imaginilor',
  'legal.bindingNote': 'Această traducere are doar scop informativ. Doar versiunea în limba germană este obligatorie din punct de vedere juridic.',
  'imprint.provider.heading': 'Informații conform § 5 DDG',
  'imprint.contact.heading': 'Contact',
  'imprint.contact.email': 'E-mail',
  'imprint.responsible.heading': 'Responsabil pentru conținut conform § 18 alin. 2 MStV',
  'privacy.intro': 'Această politică de confidențialitate explică ce date cu caracter personal sunt prelucrate atunci când vizitezi acest site.',
  'privacy.controller.heading': 'Operatorul de date',
  'privacy.controller.text': 'Responsabil pentru prelucrarea datelor pe acest site este:',
  'privacy.hosting.heading': 'Găzduire',
  'privacy.hosting.text': 'Acest site este găzduit de un furnizor extern de găzduire cu sediul în Germania. Serverele se află în Germania.',
  'privacy.serverLogs.heading': 'Fișiere jurnal ale serverului',
  'privacy.serverLogs.text': 'La fiecare accesare a acestui site, serverul salvează automat informațiile transmise de browserul tău: adresa IP, data și ora cererii, pagina accesată, volumul de date transferate, URL-ul de proveniență, precum și browserul și sistemul de operare. Aceste date sunt necesare pentru funcționarea sigură și stabilă a site-ului (art. 6 alin. 1 lit. f GDPR) și sunt șterse după cel mult 7 zile.',
  'privacy.analytics.heading': 'Măsurarea audienței',
  'privacy.analytics.text': 'Pentru a afla ce pagini sunt citite, numărăm noi înșine afișările paginilor, fără servicii externe și fără cookie-uri. Când deschizi o pagină, browserul tău transmite serverului nostru doar adresa acesteia. Pentru fiecare adresă, limbă și zi stocăm doar numărul de afișări, separat pentru browsere și programe automate (crawlere), pe care le deosebim după identificatorul browserului (user agent). Adresa ta IP, identificatorul browserului sau alte informații despre tine nu sunt stocate în acest scop; nu se pot trage concluzii despre vizitatori individuali. Dacă browserul tău trimite semnalul „Global Privacy Control” sau „Do Not Track”, vizita ta nu este numărată. Cifrele sunt șterse după un an. Temeiul juridic este art. 6 alin. 1 lit. f GDPR; interesul nostru legitim este îmbunătățirea acestui site.',
  'privacy.errorReports.heading': 'Rapoarte de erori',
  'privacy.errorReports.text': 'Dacă la încărcarea unei pagini apare o eroare tehnică, operatorului i se trimite automat un e-mail cu informații despre cererea eșuată. Acesta poate conține adresa ta IP, adresa accesată și informații despre browserul tău. Rapoartele de erori servesc exclusiv la remedierea erorilor (art. 6 alin. 1 lit. f GDPR).',
  'privacy.cookies.heading': 'Cookie-uri',
  'privacy.cookies.text': 'Acest site folosește exclusiv cookie-uri strict necesare din punct de vedere tehnic, care sunt necesare pentru sesiunea ta și pentru protecția împotriva cererilor falsificate (CSRF). Ele nu conțin date în scopuri de analiză sau publicitate și sunt șterse la închiderea browserului. Temeiul juridic este § 25 alin. 2 nr. 2 TDDDG coroborat cu art. 6 alin. 1 lit. f GDPR; nu este necesar consimțământul. Nu se folosesc servicii externe de analiză sau de urmărire; măsurarea audienței descrisă mai sus funcționează fără cookie-uri.',
  'privacy.rights.heading': 'Drepturile tale',
  'privacy.rights.text': 'Ai dreptul la:',
  'privacy.rights.access': 'acces la datele tale stocate (art. 15 GDPR)',
  'privacy.rights.rectification': 'rectificare (art. 16 GDPR)',
  'privacy.rights.erasure': 'ștergere (art. 17 GDPR)',
  'privacy.rights.restriction': 'restricționarea prelucrării (art. 18 GDPR)',
  'privacy.rights.portability': 'portabilitatea datelor (art. 20 GDPR)',
  'privacy.rights.objection': 'opoziție față de prelucrare (art. 21 GDPR)',
  'privacy.rights.contact': 'Pentru a-ți exercita aceste drepturi, trimite pur și simplu un e-mail la:',
  'privacy.complaint.heading': 'Dreptul de a depune o plângere',
  'privacy.complaint.text': 'Ai dreptul de a depune o plângere la o autoritate de supraveghere a protecției datelor. Autoritatea competentă este Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germania.',
  'privacy.updated': 'Ultima actualizare: octombrie 2026',
  'mediaLicense.intro': 'Toate fotografiile, videoclipurile, documentele și traseele de pe acest site aparțin Visit Augsburg. Le poți folosi, distribui și adapta sub licența Creative Commons Atribuire 4.0 Internațional (CC BY 4.0) – inclusiv în scop comercial – cu condiția să ne menționezi ca sursă.',
  'mediaLicense.credit.heading': 'Cum ne menționezi ca sursă',
  'mediaLicense.credit.text': 'Afișează această mențiune bine vizibil, direct lângă imagine sau videoclip:',
  'mediaLicense.credit.link': 'Pe cât posibil, pune un link către pagina de unde provine materialul și către licență. Dacă ai modificat un material, menționează acest lucru.',
  'mediaLicense.ai.heading': 'Asistenți AI și motoare de căutare',
  'mediaLicense.ai.text': 'Acest lucru este valabil și pentru chatboți, asistenți AI și motoare de căutare: cine afișează o imagine sau un videoclip de pe acest site afișează împreună cu acesta mențiunea „{{credit}}”. Autorul, mențiunea și licența apar într-o formă lizibilă de mașini în fiecare fișier de imagine (IPTC/XMP) și în datele structurate (schema.org) ale fiecărei pagini.',
  'mediaLicense.license.heading': 'Licență',
  'mediaLicense.license.text': 'Se aplică textul licenței Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Atribuire 4.0 Internațional',
  'mediaLicense.scope.heading': 'Ce nu acoperă licența',
  'mediaLicense.scope.text': 'Textele acestui site nu fac parte din licență. Datele hărților provin de la OpenStreetMap și sunt disponibile sub licența Open Database License (© contribuitorii OpenStreetMap).',
  'mediaLicense.contact': 'Ai întrebări despre utilizare? Trimite un e-mail la:',
  'mediaLicense.updated': 'Ultima actualizare: octombrie 2026',
  'gallery.previous': 'Imaginea anterioară',
  'gallery.next': 'Imaginea următoare',
  'gallery.showImage': 'Afișează {{title}}',
  'video.play': 'Redă {{title}}',
  'videoGallery.summaryOne': '1 videoclip · {{minutes}} min',
  'videoGallery.summaryOther': '{{count}} videoclipuri · {{minutes}} min',
  'tags.unesco_heritage': 'Patrimoniu UNESCO',
  'tags.landmark': 'Simbol al orașului',
  'tags.church_monastery': 'Biserică și mănăstire',
  'tags.museum_culture': 'Muzeu și cultură',
  'tags.park_nature': 'Parc și natură',
  'tags.viewpoint': 'Punct de belvedere',
  'tags.accessible': 'Accesibil',
  'tags.free': 'Gratuit',
  'tags.family_friendly': 'Pentru familii',
  'tags.concert': 'Concert',
  'tags.market': 'Piață',
  'tags.guided_tour': 'Tur ghidat',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Expoziție',
  'tags.sports': 'Sport',
  'tags.open_air': 'În aer liber',
  'tags.city_history': 'Istoria orașului',
  'tags.tips_tricks': 'Sfaturi și trucuri',
  'tags.interview': 'Interviu',
  'tags.food_drink': 'Mâncare și băutură',
  'tags.seasonal': 'Sezonier',
  'tags.behind_the_scenes': 'În culise',
  'tags.event_recap': 'Rezumatul evenimentului',
}

export default ro
